import React, { useEffect, useMemo, useState } from "react";
import ieTotal from "../../../../assets/images/ie-total.png";
import citizenClosed from "../../../../assets/images/citizen-closed.png";
import citizenPending from "../../../../assets/images/citizenpending.png";
import ieInvalid from "../../../../assets/images/ie-invalid.png";
import { getComplaintSummary } from "../../../Apis/DashboardApis/primaryDashboardApi";
import CardLoader from "../../../Common/ShimmerLoader/CardLoader";
import DashboardSectionCard from "./shared/DashboardSectionCard";
import DashboardFilters from "./shared/DashboardFilters";
import MetricStat from "./shared/MetricStat";
import useDashboardFilters from "./shared/useDashboardFilters";

const formatCount = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  return Number(value).toLocaleString();
};

const buildStats = (summary) => [
  {
    iconSrc: ieTotal,
    label: "Total Complaints",
    value: formatCount(summary?.totalComplaints),
    color: "#2563eb",
  },
  {
    iconSrc: citizenClosed,
    label: "Closed Complaints",
    value: formatCount(summary?.closedComplaints),
    color: "#16a34a",
  },
  {
    iconSrc: citizenPending,
    label: "Pending Complaints",
    value: formatCount(summary?.pendingComplaints),
    color: "#ea580c",
  },
  {
    iconSrc: ieInvalid,
    label: "Invalid Complaints",
    value: formatCount(summary?.invalidComplaints),
    color: "#4b5563",
  },
];

const IeComplaintSummary = ({ wards, data }) => {
  const {
    filters,
    appliedFilters,
    handleFilterChange,
    handleSearch,
  } = useDashboardFilters();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(!data);

  useEffect(() => {
    if (Array.isArray(data)) {
      return undefined;
    }

    let isMounted = true;

    const fetchSummary = async () => {
      try {
        setLoading(true);
        const response = await getComplaintSummary(appliedFilters, "ie");

        if (isMounted && response?.status) {
          setSummary(response?.data ?? null);
        }
      } catch (error) {
        console.error("Failed to load IE complaint summary:", error);
        if (isMounted) {
          setSummary(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchSummary();

    return () => {
      isMounted = false;
    };
  }, [appliedFilters, data]);

  const stats = useMemo(() => {
    if (Array.isArray(data)) {
      return data;
    }

    return buildStats(summary);
  }, [data, summary]);

  return (
    <DashboardSectionCard
      title="IE Complaints"
      className="pd-ie-complaint-section"
      filters={
        <DashboardFilters
          className="pd-complaint-filters"
          searchVariant="inline"
          fromDate={filters?.fromDate}
          toDate={filters?.toDate}
          ward={filters?.ward}
          wards={wards}
          onFromDateChange={(value) => handleFilterChange("fromDate", value)}
          onToDateChange={(value) => handleFilterChange("toDate", value)}
          onWardChange={(value) => handleFilterChange("ward", value)}
          onSearch={handleSearch}
          showSearch
        />
      }
    >
      {loading ? (
        <CardLoader count={4} />
      ) : (
        <div className="pd-metric-row cols-4 pd-complaint-metrics-row">
          {stats.map((item) => (
            <MetricStat key={item.label} {...item} boxed />
          ))}
        </div>
      )}
    </DashboardSectionCard>
  );
};

export default IeComplaintSummary;
